import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { InstagramApiService, InstaMedia } from 'src/app/services/instagram.service';

@Component({
  selector: 'app-instagram-feed',
  templateUrl: './instagram-feed.component.html',
  styleUrls: ['./instagram-feed.component.scss']
})
export class InstagramFeedComponent implements OnInit {
  storeId!: number;
  mediaList: InstaMedia[] = [];
  viewMode: 'personal'|'hashtag'|'mention'|'tag' = 'personal';
  currentTag = 'slicksell'; // exemplo ou capturar de algum input

  constructor(
    private route: ActivatedRoute,
    private instaApi: InstagramApiService
  ) {}

  ngOnInit(): void {
    // pega o storeId da rota /admin/store/:store/...
    this.storeId = Number(this.route.snapshot.paramMap.get('store'));
    this.loadMedia();
  }

  loadMedia(): void {
    switch (this.viewMode) {
      case 'personal':
        this.instaApi.getPersonalMedia(this.storeId)
          .subscribe(list => this.mediaList = list);
        break;

      case 'hashtag':
        this.instaApi.getHashtagMedia(this.storeId, this.currentTag)
          .subscribe(res => this.mediaList = res.data);
        break;

      case 'mention':
        this.instaApi.getMentionedMedia(this.storeId)
          .subscribe(list => this.mediaList = list);
        break;

      case 'tag':
        this.instaApi.getTaggedMedia(this.storeId)
          .subscribe(list => this.mediaList = list);
        break;
    }
  }

  onViewChange(mode: 'personal'|'hashtag'|'mention'|'tag'): void {
    this.viewMode = mode;
    this.loadMedia();
  }
}
